module.exports = __webpack_public_path__ + "media/images/contactese/email-752a2e84fd32eaad3a2c710ff864bc30.svg";